import React from "react";
import Filter from '../../../components/CRM/Filter';
import ReferenceInput from "../../../components/CRM/ReferenceInput";
import TextInput from "../../../components/CRM/TextInput";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import NullableBooleanInput from "../../../components/CRM/NullableBooleanInput";

const StoreFilter = props => {
  return (
  <Filter {...props}>
    <TextInput label="resources.stores.search" source="name_like" />

    <ReferenceInput
      label="resources.stores.inputs.storeOwner"
      source="partner_id"
      reference="partners"
      sort={{field: "first_name", order: "ASC"}}
      perPage={100}
      allowEmpty={false}
      filterToQuery={name => ({full_name_like: name})}
    >
      <AutocompleteInput
        {...props}
        optionText={record => `${record.first_name} ${record.last_name}`}
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>
    <TextInput label="resources.stores.inputs.email" source="email_like" />
    <ReferenceInput
      label="resources.stores.inputs.region"
      source="region_id"
      reference="regions"
      sort={{field: "name", order: "ASC"}}
      perPage={100}
      allowEmpty={false}
    >
      <AutocompleteInput
        {...props}
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>
    <TextInput
      label="resources.stores.fields.deviceSerialNumber"
      source="device_serial_number_like"
    />
    <NullableBooleanInput
      label="resources.stores.inputs.active"
      source="active"
      defaultValue={true}
    />
  </Filter>
)};

export default StoreFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/StoreFilter.js